import { createFileRoute, Outlet } from '@tanstack/react-router';
import { QueryBoundary } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/contracts';

const Component = () => (
    <QueryBoundary loader="overlay">
        <Outlet />
    </QueryBoundary>
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/ReservationContracts')({
    component: Component,
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
        title: TextKey.ContractsListPageTitle,
    },
});
